import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';
import { bodyScroll } from '../../utils/utils';

import ForgotPasswordConfirmationModal from '../features/account/ForgotPasswordConfirmationModal';
import InputErrors from '../common/InputErrors';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      showModal: false,
      emailResent: false,
      emailInputError: false,
      serverErrors: [],
    };
    this.emailRef = React.createRef();
  }

  toggleModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({
      showModal: !prevState.showModal,
      emailResent: false, // reset UI just in case
    }));
  }

  submit = (e) => {
    e.preventDefault();
    this.setState({
      serverErrors: [],
      emailInputError: false,
    });

    const { dispatchUsersActions } = this.props;
    const { email } = this.state;
    if (this.emailRef.current.checkValidity() && email !== '') {
      dispatchUsersActions.resetPassword(email, this.toggleModal, this.onSubmitFail);
    } else {
      this.setState({ emailInputError: true });
    }
  }

  onSubmitFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  resend = () => {
    const { dispatchUsersActions } = this.props;
    const { email } = this.state;

    dispatchUsersActions.resetPassword(email);
    this.setState({ emailResent: true });
    document.querySelector('.ReactModal__Content').focus(); // keep focus inside the modal
  }

  handleInputChange = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  }

  render() {
    const { emailInputError, email, showModal, emailResent, serverErrors } = this.state;
    // Aggregate error messages
    let errors = serverErrors;
    if (emailInputError) errors = [...errors, 'Please enter a valid email address.'];

    return (
      <Fragment>
        <Helmet>
          <title>Recover Account</title>
        </Helmet>
        <div className="fullscreen-form fullscreen-form--muted">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading fullscreen-form__heading--extra-margin">
              Recover Account
            </h1>
            <form className="form fullscreen-form__form fullscreen-form__form--extra-margin">
              {errors.length !== 0 && <InputErrors errors={errors} />}
              <label htmlFor="firstName">
                Email
              </label>
              <input
                name="email"
                id="email"
                value={email}
                onChange={this.handleInputChange}
                type="email"
                ref={this.emailRef}
              />
              <div className="fullscreen-form__button-wrapper">
                <button
                  type="submit"
                  className="button button--large"
                  onClick={this.submit}
                >
                  Reset Password
                </button>
              </div>
            </form>
          </div>
        </div>
        <ForgotPasswordConfirmationModal
          visible={showModal}
          toggleModal={this.toggleModal}
          resend={this.resend}
          emailResent={emailResent}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/ForgotPasswordPage.js